import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	securityGroup: {
		id: 'spa-apps-sidebar-global-settings-system.menu.security.security-group',
		defaultMessage: 'Security',
		description: 'Navigation group heading for security settings items',
	},
	projectRoles: {
		id: 'spa-apps-sidebar-global-settings-system.menu.security.project-roles',
		defaultMessage: 'Project roles',
		description: 'Navigation item which links to a project roles settings page',
	},
	globalPermissions: {
		id: 'spa-apps-sidebar-global-settings-system.menu.security.global-permissions',
		defaultMessage: 'Global permissions',
		description: 'Navigation item which links to a global permissions settings page',
	},
	projectRolesGalaxia: {
		id: 'spa-apps-sidebar-global-settings-system.menu.security.project-roles-galaxia',
		defaultMessage: 'Space roles',
		description: 'Navigation item which links to a project roles settings page',
	},
});
